import { createSlice } from "@reduxjs/toolkit";

export const BookAbleUntilSlice = createSlice({
    name: "bookAbleUntil",
    initialState: {
        bookAbleUntil: null,
    },
    reducers: {
        setBookAbleUntil: (state, action) => {
            state.bookAbleUntil = action.payload;
        },
        clearBookAbleUntil: (state, action) => { 
            state.bookAbleUntil = null;
        }
    }
})

export const { setBookAbleUntil, clearBookAbleUntil } = BookAbleUntilSlice.actions;

export default BookAbleUntilSlice.reducer;